import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  Text,
  Icon,
  useColorModeValue,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogBody,
  AlertDialogFooter,
  Input,
  InputGroup,
  InputLeftAddon,
  InputRightElement,
  Stack,
} from "@chakra-ui/react";

import React, { useMemo, useEffect, useState } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { useHistory } from "react-router-dom";
import AuthService from "services/auth.services.js";
import ApiService from "services/api.js";
// Custom components
import Card from "components/card/Card";
import Menu from "components/menu/MainMenu";
import Pagination from "components/dataDispaly/Pagination";
import BranchTable from "./branchTable";
import { columnsBranch } from "views/admin/roleManagement/variables/branchData";

// Assets
import {
  MdCheckCircle,
  MdCancel,
  MdUpdate,
  MdDelete,
  MdWarning,
  MdCreate,
} from "react-icons/md";
export default function RoleTable(props) {
  // custom variable

  const history = useHistory();

  // Use state variable
  const { columnsData } = props;
  const [data, setData] = useState([]);
  const [dataPage, setDataPage] = useState([]);
  const [dataPageSize, setDataPageSize] = useState(5);
  const [loading, setLoading] = useState(true);
  const [inputRoleName, setRoleName] = useState();
  const [inputRoleDesc, setRoleDesc] = useState();
  const [selectedRow, setSelectedRow] = useState();
  const [show, setShow] = React.useState(false);
  const [selectedRowsBranch, setSelectedRowsBranch] = useState([]);
  const [selectedRowsMenu, setSelectedRowsMenu] = useState([]);
  //const [searchTerm, setSearchTerm] = useState('');
  const handleClick = () => setShow(!show);
  const [dataBranch, setDataBranch] = useState([]);
  const [dataMenu, setDataMenu] = useState([]);


  // ref variable
  const skipPageResetRef = React.useRef();
  const cancelRef = React.useRef();
  // memo variable
  const columns = useMemo(() => columnsData, [columnsData]);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();

  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();

  const {
    isOpen: isOpen3,
    onOpen: onOpen3,
    onClose: onClose3,
  } = useDisclosure();

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageCount: dataPage },
      manualPagination: true,
      pageCount: dataPage,
      autoResetPage: !skipPageResetRef.current,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const updateRole = async (dataRole) => {
    try {
      
      // Get the current user data
      const userData = JSON.parse(localStorage.getItem("verified_user")) || {};
      if(userData.role_id === dataRole.id){
      // Remove all items that are in the selected list and add the fresh data
      const updatedUserData = {
        email: userData.email,
        token: userData.token,
        roleBranch: [], // This will be populated with fresh data
        roleMenu: [],    // This will be populated with fresh data
        role_id: userData.role_id
      };

      // Then add the newly created items
      const newBranchList = selectedRowsBranch.map(id => {
        const branch = dataBranch.find(branch => branch.id === id);
        return {
          id: id,
          name_branch: branch ? branch.name_branch : `${id}`,
          address: "",
          phone: "",
          city: "",
          province: "",
          created_by: 0,
          updated_by: 0,
          deleted_by: 0,
          created_at: "2025-03-08T19:54:07.8096417+07:00",
          updated_at: "2025-03-08T19:54:07.8096417+07:00"
        };
      });

      // Add the new items
      updatedUserData.roleBranch = newBranchList;

      // Then add the newly created items
      const newMenuList = selectedRowsMenu.map(id => {
        const menu = dataMenu.find(menu => menu.id === id);
        return {
          id: id,
          menu_name: menu ? menu.menu_name : `${id}`,
          menu_desc: "",
          created_by: 0,
          updated_by: 0,
          deleted_by: 0,
          created_at: "2025-03-08T19:54:07.8096417+07:00",
          updated_at: "2025-03-08T19:54:07.8096417+07:00",
          DeletedAt: null
        };
      });
      // Add the new items
      updatedUserData.roleMenu = newMenuList;

      // remove old verified user
      localStorage.removeItem("verified_user");

      // add new verified user
      localStorage.setItem("verified_user", JSON.stringify(updatedUserData));
    }

      let response = await ApiService.client
        .put(
          `/auth/updateRoles/` + dataRole.id,
          { role_name: inputRoleName, role_desc: inputRoleDesc, branch_ids: selectedRowsBranch, menu_ids: selectedRowsMenu },
          await ApiService.options()
        )
        .then((response) => {
          window.location.reload();
        });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const createRole = async () => {
    try {
      let response = await ApiService.client
        .post(
          `/auth/createRoles`,
          {
            role_name: inputRoleName,
            role_desc: inputRoleDesc,
            branch_ids: selectedRowsBranch,
            menu_ids: selectedRowsMenu,
          },
          await ApiService.options()
        )
        .then((response) => {
          window.location.reload();
        });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const deleteRole = async (dataRole) => {
    try {
      let response = await ApiService.client
        .delete(
          `/auth/deleteRoles/` + dataRole.row.cells[0].value,
          await ApiService.options()
        )
        .then((response) => {
          window.location.reload();
        });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    setLoading(true);
    try {

      const fetchData = async () => {
        try {
          skipPageResetRef.current = true;
          let response = await ApiService.client.get(
            `/auth/getRoles/${pageIndex + 1
            }/${dataPageSize}`,
            await ApiService.options()
          );
          let responseBranch = await ApiService.client.get(
            '/branch/getAllBranch',
            await ApiService.options()
          )
          // console.log("rteas", responseBranch)

          if (Array.isArray(responseBranch)) {
            responseBranch.sort((a, b) => a.name_branch.localeCompare(b.name_branch)); // Sort by name_branch
          }
          let responseMenu = await ApiService.client.get(
            '/menu/getAllmenu',
            await ApiService.options()
          )
          // console.log("rteas", responseMenu)
         // console.log("total halaman", response.data);
          setDataPage(response.data["total_halaman"]);
          setPageSize(dataPageSize);
          setData(response.data.role);
          setDataBranch(responseBranch.data.branches)
          setDataMenu(responseMenu.data.menus)
          skipPageResetRef.current = false;
        } catch (error) {
          //if (error.response.status === 401) {
          // AuthService.logout().then(
          //   () => {
         //     console.log("Success Logout");
          //   },
          //   (error) => {
          //     (error.response &&
          //       error.response.data &&
          //       error.response.data.message) ||
          //       error.message ||
          //       error.toString();
          //   }
          // );
          // history.push("/auth/sign-in");
          //}

          // console.log("error ni", error.response);
        }
      };
      fetchData();
    } catch (error) {
      // if (error.response.status === 401) {
      //   // history.push("/auth/sign-in");
      // }
      // console.log(error);
    }
  }, [pageIndex, dataPage, dataPageSize, pageSize]);

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  function setRow(data) {
    setSelectedRow(data);
    onOpen(true);
  }

  function setRowUpdate(data) {

    const mappedDataBranch = data.row.original.RolePermissionBranch.map(branch => branch.id);
    const mappedDataMenu = data.row.original.RolePermissionMenu.map(menu => menu.id);
   // console.log("DATA", data.row.original)
   // console.log("DATA", mappedDataMenu)
    setSelectedRow(data.row.original)
    setSelectedRowsBranch(mappedDataBranch);
    setSelectedRowsMenu(mappedDataMenu);
    setRoleName(data.row.cells[1].value);
    setRoleDesc(data.row.cells[2].value);
    onOpen2(true);
  }

  function setRowDelete(data) {
    setSelectedRow(data);
    onOpen1(true);
  }

  return (
    <Card
      direction={{ base: "column", sm: "row" }}
      w="100%"
      px="0px"
      overflowX={{ sm: "scroll", md: "scroll", lg: "scroll" }}
    >
      <Flex px="25px" justify="space-between" mb="20px" align="center">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
        >
          Role Management
        </Text>
        {/* <Menu /> */}
      </Flex>

      {/* Modal For Disable/Enable Role */}
      {/* <Modal
        isCentered
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay
          bg="blackAlpha.300"
          backdropFilter="blur(10px) hue-rotate(0deg)"
        />
        <ModalContent>
          <ModalHeader>Please Confirm</ModalHeader>
          <ModalBody>Are you sure to do this?</ModalBody>

          <ModalFooter>
            <Button mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button
              colorScheme="red"
              onClick={() => enableDisableRole(selectedRow)}
            >
              Yes
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal> */}

      {/* Modal For Create Role */}
      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpen3}
        onClose={onClose3}
        size="full"
      >
        <ModalOverlay
          bg="blackAlpha.300"
          backdropFilter="blur(10px) hue-rotate(0deg)"
        />
        <ModalContent>
          <ModalHeader>Create Role</ModalHeader>
          <ModalBody>
            <InputGroup mb={5}>
              <InputLeftAddon children="Rolename" />
              <Input
                focusBorderColor="black"
                placeholder="Input Rolename"
                borderRadius="16px"
                value={inputRoleName}
                onChange={(e) => setRoleName(e.target.value)}
              />
            </InputGroup>
            <InputGroup mb={5}>
              <InputLeftAddon children="Description" />
              <Input
                focusBorderColor="black"
                placeholder="Input Description"
                borderRadius="16px"
                value={inputRoleDesc}
                onChange={(e) => setRoleDesc(e.target.value)}
              />
            </InputGroup>
            <InputGroup mb={3}>
              <InputLeftAddon children="Branch" />
              <BranchTable data={dataBranch} columnsData={columnsBranch} selectedRows={selectedRowsBranch} setSelectedRows={setSelectedRowsBranch} />
              <InputLeftAddon children="Menu" ml={10} />
              <BranchTable data={dataMenu} columnsData={columnsBranch} selectedRows={selectedRowsMenu} setSelectedRows={setSelectedRowsMenu} />
            </InputGroup>

            {/* <InputGroup mb={5}>
              <InputLeftAddon children="Email" />
              <Input
                focusBorderColor="black"
                placeholder="Input Email"
                borderRadius="16px"
                value={inputEmail}
                onChange={(e) => setEmail(e.target.value)}
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon children="Password" />
              <Input
                focusBorderColor="black"
                placeholder="Input Password"
                borderRadius="16px"
                value={inputPassword}
                type={show ? "text" : "password"}
                onChange={(e) => setPassword(e.target.value)}
              />
              <InputRightElement width="4.5rem">
                <Button h="1.75rem" size="sm" onClick={handleClick}>
                  {show ? "Hide" : "Show"}
                </Button>
              </InputRightElement>
            </InputGroup> */}
          </ModalBody>

          <ModalFooter>
            <Button mr={3} onClick={onClose3}>
              Cancel
            </Button>
            <Button colorScheme="facebook" onClick={() => createRole()}>
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Modal For Update Role */}
      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpen2}
        onClose={onClose2}
        size="full"
      >
        <ModalOverlay
          bg="blackAlpha.300"
          backdropFilter="blur(10px) hue-rotate(0deg)"
        />
        <ModalContent>
          <ModalHeader>Update Role</ModalHeader>
          <ModalBody>
            <InputGroup mb={5}>
              <InputLeftAddon children="Rolename" />
              <Input
                focusBorderColor="black"
                placeholder="Input Rolename"
                borderRadius="16px"
                value={inputRoleName}
                onChange={(e) => setRoleName(e.target.value)}
              />
            </InputGroup>
            <InputGroup mb={5}>
              <InputLeftAddon children="Description" />
              <Input
                focusBorderColor="black"
                placeholder="Input Description"
                borderRadius="16px"
                value={inputRoleDesc}
                onChange={(e) => setRoleDesc(e.target.value)}
              />
            </InputGroup>
            <InputGroup mb={3}>
              <InputLeftAddon children="Branch" />
              <BranchTable data={dataBranch} columnsData={columnsBranch} selectedRows={selectedRowsBranch} setSelectedRows={setSelectedRowsBranch} />
              <InputLeftAddon children="Menu" ml={10} />
              <BranchTable data={dataMenu} columnsData={columnsBranch} selectedRows={selectedRowsMenu} setSelectedRows={setSelectedRowsMenu} />
            </InputGroup>
          </ModalBody>

          <ModalFooter>
            <Button mr={3} onClick={onClose2}>
              Cancel
            </Button>
            <Button
              colorScheme="facebook"
              onClick={() => updateRole(selectedRow)}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Alert For Delete Role */}
      <AlertDialog
        isOpen={isOpen1}
        leastDestructiveRef={cancelRef}
        onClose={onClose1}
      >
        <AlertDialogOverlay
          bg="none"
          backdropFilter="auto"
          backdropInvert="100%"
        >
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Role
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure? You can't undo this action afterwards.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose1}>
                Cancel
              </Button>
              <Button
                colorScheme="red"
                onClick={() => deleteRole(selectedRow)}
                ml={3}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      <Stack
        px="20px"
        justify="space-between"
        mb="20px"
        align="center"
        spacing={4}
        direction="row"
      >
        <Button
          leftIcon={<MdCreate />}
          colorScheme="blue"
          size="md"
          borderRadius="lg"
          onClick={onOpen3}
        >
          Create
        </Button>
      </Stack>

      <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
        <Thead>
          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column, index) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  pe="10px"
                  key={index}
                  borderColor={borderColor}
                >
                  <Flex
                    justify="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    {column.render("Header")}
                  </Flex>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {page.map((row, index) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()} key={index}>
                {row.cells.map((cell, index) => {
                  let data = "";
                  if (cell.column.Header === "ROLE NAME") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "DESCRIPTION") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "UPDATE") {
                    data = (
                      <Button
                        leftIcon={<MdUpdate />}
                        colorScheme="teal"
                        size="sm"
                        borderRadius="xl"
                        onClick={() => setRowUpdate(cell)}
                      >
                        Update
                      </Button>
                    );
                  } else if (cell.column.Header === "DELETE") {
                    data = (
                      <Button
                        isDisabled={
                          cell.row.cells[3].value === true ? true : false
                        }
                        leftIcon={<MdDelete />}
                        colorScheme="red"
                        size="sm"
                        borderRadius="xl"
                        onClick={() => setRowDelete(cell)}
                      >
                        Delete
                      </Button>
                    );
                  }
                  return (
                    <Td
                      {...cell.getCellProps()}
                      key={index}
                      fontSize={{ sm: "14px" }}
                      minW={{ sm: "150px", md: "200px", lg: "auto" }}
                      borderColor="transparent"
                    >
                      {data}
                    </Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
      <Pagination
        canNextPage={canNextPage}
        nextPage={nextPage}
        canPreviousPage={canPreviousPage}
        previousPage={previousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        gotoPage={gotoPage}
        pageSize={pageSize}
        setDataPageSize={setDataPageSize}
        pageCount={pageCount}
      />
    </Card>
  );
}
